import workspaceQuery from '../../../graphql/queries/product/AssemblyAssignmentWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/product/AssemblyAssignmentQuery.graphql';
import mutationQuery from '../../../graphql/mutations/product/AssemblyAssignmentMutation.graphql';
import fragment from '../../../graphql/fragments/product/AssemblyAssignmentFragment.graphql';

import { EntityType } from '../../../@types/entityTypes';
import { ALLOW_ADD, ALLOW_DELETE, ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const AssemblyAssignment: EntityType = {
  type: 'AssemblyAssignment',
  title: 'Assembly Assignments',
  formUrl: '/Products/Assembly/Assignment/Details/',
  formTitle: 'Assembly Assignments',
  workspaceUrl: '/Products/Assembly/Assignment/Workspace/',
  workspace: workspaceQuery,
  instance: instanceQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'ASSEMBLY_ASSIGNMENT',
  operations: ALLOW_VIEW | ALLOW_DELETE | ALLOW_ADD | ALLOW_EDIT,
};

export default AssemblyAssignment;
